import { ExtensionType, settings, extensions } from '@pixi/core';
import '../../loader/index.mjs';
import { loadTextures } from '../../loader/parsers/textures/loadTexture.mjs';
var resolveTextureUrl = {
  extension: ExtensionType.ResolveParser,
  test: loadTextures.test,
  parse: function parse(value) {
    var _settings$RETINA_PREF, _settings$RETINA_PREF2;
    return {
      resolution: parseFloat((_settings$RETINA_PREF = (_settings$RETINA_PREF2 = settings.RETINA_PREFIX.exec(value)) === null || _settings$RETINA_PREF2 === void 0 ? void 0 : _settings$RETINA_PREF2[1]) !== null && _settings$RETINA_PREF !== void 0 ? _settings$RETINA_PREF : "1"),
      format: value.split(".").pop(),
      src: value
    };
  }
};
extensions.add(resolveTextureUrl);
export { resolveTextureUrl };